<template>
  <div>
    <el-table :data="displayData" style="width: 100%">
      <el-table-column prop="reference" label="reference" width="150" />
      <el-table-column prop="user_groups" label="user_groups" width="150" />
      <el-table-column prop="Title" label="Title" width="150" />
      <el-table-column prop="first_name" label="first_name" width="150" />
      <el-table-column prop="Last_name" label="Last_name" width="150" />
      <el-table-column prop="maiden_name" label="maiden_name" width="150" />
      <el-table-column prop="Middle_name" label="Middle_name" width="150" />
      <el-table-column prop="preferred_first_name" label="preferred_first_name" width="150" />
      <el-table-column prop="suffix_1" label="suffix_1" width="150" />
      <el-table-column prop="DOB" label="DOB" width="150" />
      <el-table-column prop="from" label="from" width="150" />
      <el-table-column prop="to" label="to" width="150" />
      <el-table-column prop="gender" label="gender" width="150" />
      <el-table-column prop="class_of" label="class_of" width="150" />
      <el-table-column prop="start_year_group" label="start_year_group" width="150" />
      <el-table-column prop="end_year_group" label="end_year_group" width="150" />
      <el-table-column prop="house" label="house" width="150" />
      <el-table-column prop="default" label="default" width="150" />
      <el-table-column prop="email" label="email" width="150" />
      <el-table-column prop="addition_email_type" label="addition_email_type" width="150" />
      <el-table-column prop="additional_email" label="additional_email" width="150" />
      <el-table-column prop="address_type" label="address_type" width="150" />
      <el-table-column prop="address_1" label="address_1" width="150" />
      <el-table-column prop="address_2" label="address_2" width="150" />
      <el-table-column prop="address_3" label="address_3" width="150" />
      <el-table-column prop="address_city" label="address_city" width="150" />
      <el-table-column prop="address_county_state" label="address_county_state" width="150" />
      <el-table-column prop="st_prm_add_country" label="st_prm_add_country" width="150" />
      <el-table-column prop="st_prm_add_pstcode" label="st_prm_add_pstcode" width="150" />
      <el-table-column prop="phone_number_type" label="phone_number_type" width="150" />
      <el-table-column prop="phone_country_code" label="phone_country_code" width="150" />
      <el-table-column prop="phone_number" label="phone_number" width="150" />
      <el-table-column prop="mobile_country_code" label="mobile_country_code" width="150" />
      <el-table-column prop="mobile_number" label="mobile_number" width="150" />
      <el-table-column prop="Nationality" label="Nationality" width="150" />
      <el-table-column prop="industry_experience" label="industry_experience" width="150" />
      <el-table-column prop="note_category" label="note_category" width="150" />
      <el-table-column prop="notes" label="notes" width="150" />
      <el-table-column prop="deceased" label="deceased" width="150" />
      <el-table-column prop="deceased_date" label="deceased_date" width="150" />
      <el-table-column prop="education_institution" label="education_institution" width="150" />
      <el-table-column prop="education_start_date" label="education_start_date" width="150" />
      <el-table-column prop="education_end_date" label="education_end_date" width="150" />
      <el-table-column prop="education_subject" label="education_subject" width="150" />
      <el-table-column prop="education_level_studied" label="education_level_studied" width="150" />
      <el-table-column prop="education_country" label="education_country" width="150" />
      <el-table-column prop="education_course" label="education_course" width="150" />
      <el-table-column prop="work_employer" label="work_employer" width="150" />
      <el-table-column prop="work_industry" label="work_industry" width="150" />
      <el-table-column prop="work_start_date" label="work_start_date" width="150" />
      <el-table-column prop="work_end_date" label="work_end_date" width="150" />
      <el-table-column prop="work_position" label="work_position" width="150" />
      <el-table-column prop="individual_letter_salutation" label="individual_letter_salutation " width="150" />
      <el-table-column prop="individual_envelope_label_salutation" label="individual_envelope_label_salutation " width="150" />
      <el-table-column prop="School_custom_value" label="School_custom_value" width="150" />
      <el-table-column prop="School_name_custom_value" label="School_name_custom_value" width="150" />
      <el-table-column prop="stud_no" label="student_no" width="150" />
    </el-table>
    <el-pagination
      v-if="dataList"
      small
      background
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :total="dataList.length"
      :page-size="pageSize"
      class="mt-4"
    />
  </div>
</template>

<script>
import uiVariable from '../../../config/uiVariable'
import K2Text from '../../../uiComponents/k2Text/k2Text'
import K2Row from '../../../uiComponents/k2Row/k2Row'
import K2Button from '../../../uiComponents/k2Button/k2Button'

export default {
  name: 'AlumiReportTable',
  components: {},
  props: ['onclick', 'tabList', 'dataList', 'dateRange'],
  data() {
    return {
      uiVariable: uiVariable,
      pageSize: 10,
      page: 1,
      tableData: [
        {
          teacher: 'Teacher A',
          Moments: 100,
          students: 100,
        },
      ],
    }
  },
  computed: {
    displayData() {
      if (this.dataList && this.dataList.length) {
        // this.dataList.forEach(m =>{
        //   if (m.DOB !== undefined){
        //     let tempDate = new Date(m.DOB);
        //     m.DOB =tempDate.getDate() +"/" + (tempDate.getMonth() +1)+"/"+tempDate.getFullYear();
        //   }
        //
        // })
        this.total = this.dataList.length
        return this.dataList.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page)
      }
    },
  },
  watch: {
    // dataList: function (value) { // watch it
    //   if (value) {
    //     this.handleDataList(value);
    //   }
    // },
  },
  async mounted() {
    // this.handleDataList();
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val
    },
  },
}
</script>

<style scoped></style>
